var map = {
	"./logo-jaguar.png": 409,
	"./logo-jet2.png": 410,
	"./logo-jet2holidays.png": 411,
	"./logo-landrover.png": 412
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 418;



//////////////////
// WEBPACK FOOTER
// ./src/img ^\.\/logo\-.*\.png$
// module id = 418
// module chunks = 114276838955818